export const TERMS_OF_SERVICE_URL = "https://clipboardhealth.com/terms-of-service?menu=none";
export const PRIVACY_POLICY_URL = "https://clipboardhealth.com/privacy-policy?menu=none";
